import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'supremics_reading_progress';

export function useReadingProgress() {
  const [progress, setProgress] = useState({});

  // Load progress from localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        setProgress(JSON.parse(stored));
      }
    } catch (e) {
      console.error('Error loading reading progress:', e);
    }
  }, []);

  // Save progress to localStorage
  const saveProgress = useCallback((comicId, episodeId, episodeNumber, scrollPosition = 0) => {
    setProgress(prev => {
      const updated = {
        ...prev,
        [comicId]: {
          episodeId,
          episodeNumber,
          scrollPosition,
          lastRead: new Date().toISOString()
        }
      };
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      } catch (e) {
        console.error('Error saving reading progress:', e);
      }
      return updated;
    });
  }, []);

  // Get progress for a specific comic
  const getProgress = useCallback((comicId) => {
    return progress[comicId] || null;
  }, [progress]);

  // Clear progress for a comic
  const clearProgress = useCallback((comicId) => {
    setProgress(prev => {
      const updated = { ...prev };
      delete updated[comicId];
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      } catch (e) {
        console.error('Error clearing reading progress:', e);
      }
      return updated;
    });
  }, []);

  // Get all progress sorted by last read
  const getAllProgress = useCallback(() => {
    return Object.entries(progress)
      .map(([comicId, data]) => ({
        comicId,
        ...data
      }))
      .sort((a, b) => new Date(b.lastRead) - new Date(a.lastRead));
  }, [progress]);

  return {
    progress,
    saveProgress,
    getProgress,
    clearProgress,
    getAllProgress
  };
}

export default useReadingProgress;
